import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { urlEndPoint } from 'src/app/common';
import { News } from 'src/app/models/obs/news';
import { Log } from 'src/app/models/user-log';
import { AccessService } from 'src/app/services/access.service';
import { NewsService } from 'src/app/services/obs/news.service';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserLogService } from 'src/app/services/user-log.service';
import { UploadfileService } from 'src/app/services/util/uploadfile.service';
import { UtilLogService } from 'src/app/services/util/util-log.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-admmeeting-form',
  templateUrl: './admmeeting-form.component.html',
  styleUrl: './admmeeting-form.component.scss'
})
export class AdmmeetingFormComponent implements OnInit {

  form: FormGroup;
  news: News = null;

  edit: boolean = false;
  idtier3Selected: number = null;
  isUploadDir: boolean = false;
  filename: string = null;
  URL: string = urlEndPoint;
  uploatedFile: File;

  dataLog = {};
  movesLog: Log[] = null;
  accessMP: boolean = false;
  inf = {}
  tempfilenamePDF: string[] = [];
  isUploadPdfDir: boolean = false;
  filenamePDF: string[] = [];
  tempdirectoryPDF: string[] = [];
  uploatedFilePDF: File[] = [];

  constructor(
    private accesService: AccessService,
    private ts: TokenStorageService,
    private router: Router,
    private newS: NewsService,
    private fb: FormBuilder,
    private activedRoute: ActivatedRoute,
    private userLogService: UserLogService,
    private utilLogservice: UtilLogService,
    private uploadS: UploadfileService
  ) { }

  ngOnInit() {
    const params = this.activedRoute.snapshot.params;
    this.createForm();
    this.getNew(params);
    this.getPermission();
  }

  createForm() {
    this.form = this.fb.group({
      id: [null],
      ideditor: [null],
      title: ['', Validators.required],
      autor: ['', Validators.required],
      date: ['', Validators.required],
      content: ['', Validators.required],
      source: ['', Validators.required],
      img: [],
      type: [1],
      status: [],
      tags: [],
      dateexpiry: [''],
      urls: [null],
      doc: [null],
      doc_name: [null]
    })
  }

  verifiedImgDirectory() {
    if (this.news.img != null) {
      (this.news.img.substring(1, 7) === 'upload') ? this.isUploadDir = true : this.isUploadDir = false;
    }
  }

  getNew(params: any) {
    if (params.id) {
        this.newS.getOne(params.id).subscribe({
            next: res => {
                this.news = res['data'];
                this.getLog();
                this.verifiedImgDirectory();
                this.verifiedPdfDirectory();
                this.loadData();
                this.loadpdf();
                this.edit = true;
            },
            error: err => console.error(err)
        });
    } else {
        this.edit = false;
    }
}

  loadData() {
    this.form.reset(this.news);
  }

  onFileChange(e) {
    this.uploatedFile = e.target.files;
    const reader = new FileReader();
    reader.onload = (e) => {
      this.form.get('img').setValue(e.target['result']);
    };
    reader.readAsDataURL(this.uploatedFile[0]);
  }

  cancel() {
    this.router.navigate(['/adm/encuentro/list']);
  }


  save() {
    if (this.form.invalid) {
        return Object.values(this.form.controls).forEach(control => {
            if (control instanceof FormGroup) {
                Object.values(control.controls).forEach(control => control.markAsTouched());
            } else {
                control.markAsTouched();
            }
        });
    } else {
        (this.uploatedFile != null || this.uploatedFilePDF.length > 0) ? this.onUpload() : this.saveOrUpdate();
    }
}

  onUpload() {
    const observables = [];

    if (this.uploatedFile) {
        const formData = new FormData();
        formData.append("uploads", this.uploatedFile[0], this.uploatedFile[0].name);
        observables.push(this.uploadS.uploadFile(formData));
    }

    if (this.uploatedFilePDF && this.uploatedFilePDF.length > 0) {
        for (const pdfFile of this.uploatedFilePDF) {
            const formDataPDF = new FormData();
            formDataPDF.append("uploads", pdfFile, pdfFile.name);
            observables.push(this.uploadS.uploadFilePDFEncuentro(formDataPDF));
        }
    }

    if (observables.length > 0) {
        forkJoin(observables).subscribe({
            next: (responses) => {
                if (responses.length > 0) {
                    let responseIndex = 0;

                    if (this.uploatedFile) {
                        this.filename = responses[responseIndex].filename;
                        responseIndex++;
                    }
                    if (this.uploatedFilePDF && this.uploatedFilePDF.length > 0) {
                        for (let i = 0; i < this.uploatedFilePDF.length; i++) {
                            this.filenamePDF[i] = responses[responseIndex].filename;
                            responseIndex++;
                        }
                    }
                }
                this.saveOrUpdate();
            },
            error: (error) => {
                console.error(error);
            }
        });
    } else {
        this.saveOrUpdate();
    }
}

  saveOrUpdate() {
    this.edit ? this.update(this.form.value.id, this.form.value) : this.create(this.form.value);
    this.router.navigate(['/adm/encuentro/list']);
  }

  create(news: News) {
    delete news.id;
    const sizeOnDb = this.tempdirectoryPDF.length;
    const urlsValue = this.form.get('urls').value;
    if (typeof urlsValue === 'string') {
        news.urls = urlsValue.split('\n');
    }
    if (this.filename) { news.img = '/uploads/' + this.filename; }
    news.type = 1;
    if (!news.dateexpiry) {
        news.dateexpiry = null;
    }

    // Manejo de PDFs
    if (this.filenamePDF) {
        if (this.tempfilenamePDF.length > 0) {
            news.doc = [];
            news.doc_name = [];
            for (let i = 0; i < this.tempdirectoryPDF.length; i++) {
                news.doc[i] = this.tempdirectoryPDF[i];
                news.doc_name[i] = this.tempfilenamePDF[i];
            }

            for (let i = 0; i < this.uploatedFilePDF.length; i++) {
                news.doc[this.tempdirectoryPDF.length + i] = '/uploads/encuentros/docs/' + this.filenamePDF[i];
                news.doc_name[this.tempdirectoryPDF.length + i] = this.tempfilenamePDF[i + sizeOnDb];
            }
        } else {
            if (this.uploatedFilePDF.length == 0) {
                news.doc = [];
                news.doc_name = [];
            }
            for (let i = 0; i < this.uploatedFilePDF.length; i++) {
                news.doc[i] = '/uploads/encuentros/docs/' + this.filenamePDF[i];
                news.doc_name[i] = this.tempfilenamePDF[i + sizeOnDb];
            }
        }
    }

    this.newS.createEv(news).subscribe({
        next: res => { if (res) this.utilLogservice.createLog(res['data'], 'creación', 'Lista encuentro'); },
        error: err => { console.error(err) }
    });
}

  update(id: string, news: News) {
    const data = { ...news };
    delete news.id;
    const sizeOnDb = this.tempdirectoryPDF.length;
    const urlsValue = this.form.get('urls').value;
    if (typeof urlsValue === 'string') {
        news.urls = urlsValue.split('\n');
    }
    if (this.filename) { news.img = '/uploads/' + this.filename; }
    news.type = 1;
    if (!news.dateexpiry) {
        news.dateexpiry = null;
    }

    // Manejo de PDFs
    if (this.filenamePDF) {
        if (this.tempfilenamePDF.length > 0) {
            news.doc = [];
            news.doc_name = [];
            for (let i = 0; i < this.tempdirectoryPDF.length; i++) {
                news.doc[i] = this.tempdirectoryPDF[i];
                news.doc_name[i] = this.tempfilenamePDF[i];
            }

            for (let i = 0; i < this.uploatedFilePDF.length; i++) {
                news.doc[this.tempdirectoryPDF.length + i] = '/uploads/encuentros/docs/' + this.filenamePDF[i];
                news.doc_name[this.tempdirectoryPDF.length + i] = this.tempfilenamePDF[i + sizeOnDb];
            }
        } else {
            if (this.uploatedFilePDF.length == 0) {
                news.doc = [];
                news.doc_name = [];
            }
            for (let i = 0; i < this.uploatedFilePDF.length; i++) {
                news.doc[i] = '/uploads/encuentros/docs/' + this.filenamePDF[i];
                news.doc_name[i] = this.tempfilenamePDF[i + sizeOnDb];
            }
        }
    }

    this.newS.updateEv(id, news).subscribe({
        next: res => { if (res) this.utilLogservice.createLog(data, 'edición', 'Lista encuentro'); },
        error: err => { console.error(err) }
    });
}

  campoNoValido(campo: string) {
    return this.form.get(campo).invalid && this.form.get(campo).touched;
  }

  /* Obtener ultimos moviemientos de los usuarios en el compoente */
  getLog() {
    const term = this.activedRoute.snapshot['_routerState'].url.split('/')[2];
    const idContent = this.activedRoute.snapshot.params['id'];
    this.userLogService.getLastLogByContent(idContent, term).subscribe({
      next: res => { this.movesLog = res['data'] || []; },
      error: err => console.error(err)
    });
  }

  getPermission() {
    this.inf['userId'] = this.ts.getUser().id;
    this.inf['accessId'] = 12;//este id es del modulo de reportes
    const data = this.inf;
    this.accesService.getPermissionUser(data).subscribe({
      next: res => {
        this.accessMP = res['result'] ? true : false;
      }
    });
  }

  getFormattedUrls(): string {
    const urls = this.form.get('urls').value;
    return Array.isArray(urls) ? urls.join('\n') : urls;
  }

  onUrlInputChange() {
    const urls = this.form.get('urls').value;
    if (typeof urls === 'string') {
      const urlsArray = urls.split('\n');
      const invalidUrls = urlsArray.filter(url => !this.isYouTubeEmbedUrl(url));

      if (invalidUrls.length > 0) {
        this.showErrorMessage("Algunas URLs no son del tipo embed de YouTube. Debes utilizar URLs de tipo embed.");
      } else {
        this.hideErrorMessage();
      }
    }
  }

  isYouTubeEmbedUrl(url: string): boolean {
    return url.includes('youtube.com/embed');
  }

  errorMessage: string | null = null;
  showErrorMessage(message: string) {
    this.errorMessage = message;
  }

  hideErrorMessage() {
    this.errorMessage = null;
  }

  /* PDF */

  updatetempfilenamePDF(index: number, newValue: string) {
    this.tempfilenamePDF[index] = newValue;
}

verifiedPdfDirectory() {
    if (this.news.doc && this.news.doc.some((pdfPath) => pdfPath.startsWith('/uploads'))) {
        this.isUploadPdfDir = true;
    } else {
        this.isUploadPdfDir = false;
    }
}

loadpdf() {
    this.tempfilenamePDF = [];
    if (this.news.doc && this.news.doc.length > 0) {
        for (const pdfPath of this.news.doc) {
            const pdfName = pdfPath.substring(pdfPath.lastIndexOf('/') + 1);
            if (pdfPath && pdfPath.trim() !== "") {
                this.filenamePDF.push(pdfName);
                this.tempdirectoryPDF.push(pdfPath);
            }
        }
    }

    if (this.news.doc_name && this.news.doc_name.length > 0) {
        for (const pdfPath of this.news.doc_name) {
            if (pdfPath && pdfPath.trim() !== "") {
                this.tempfilenamePDF.push(pdfPath);
            }
        }
    }
}

onPdfChange(event: any) {
    const newSelectedPdfFiles = event.target.files;
    for (let i = 0; i < newSelectedPdfFiles.length; i++) {
        this.uploatedFilePDF.push(newSelectedPdfFiles[i]);
        this.tempfilenamePDF.push(newSelectedPdfFiles[i].name);
    }
}

removePdf(index: number) {
    if (this.tempdirectoryPDF[index]) {
        const pdfPath = this.tempdirectoryPDF[index];
        const parts = pdfPath.split('/');
        const filename = parts[parts.length - 1];

        const confirmation = confirm(`¿Estás seguro de que deseas eliminar el archivo "${filename}"?`);

        if (confirmation) {
            if (pdfPath.startsWith('/uploads')) {
                this.uploadS.deletedFileEncuentro(filename).subscribe(
                    () => {
                        this.tempdirectoryPDF.splice(index, 1);
                        this.tempfilenamePDF.splice(index, 1);
                        this.uploatedFilePDF.splice(index, 1);
                        this.filenamePDF.splice(index, 1);
                    },
                    (error) => {
                        console.error(`Error al eliminar el archivo: ${error}`);
                    }
                );
            } else {
                this.tempdirectoryPDF.splice(index, 1);
                this.tempfilenamePDF.splice(index, 1);
                this.uploatedFilePDF.splice(index, 1);
                this.filenamePDF.splice(index, 1);
            }
        }
    }
}

}
